import { send } from '../../../../../../src/network';
import { type HouseholdSize } from '../../../../../../src/types/HouseholdSize';

export interface QuizResponse {
  customer_id: number;
  household_size: HouseholdSize | null;
  num_adults: number | null;
  num_young_children: number | null;
  num_older_children: number | null;
  weekly_grocery_spend: number | null;
  breakfast_meal_snack: number | null;
  lunch_meal_snack: number | null;
  dinner_meal_snack: number | null;
  breakfast_frequency: number | null;
  lunch_frequency: number | null;
  dinner_frequency: number | null;
  snack_frequency: number | null;
  sweets_frequency: number | null;
  fruit_frequency: number | null;
  kid_snack_frequency: number | null;
}

export async function getCustomerQuizzes() {
  return await send<QuizResponse>({
    path: `/api/v2/customers/self/quizzes/`,
    method: 'GET',
  });
}
